import { SettingsContainerRoot } from "./SettingsContainerRoot/SettingsContainerRoot";
import { SettingsContainerNav } from "./SettingsContainerNav/SettingsContainerNav";
import { SettingsContainerContent } from "./SettingsContainerContent/SettingsContainerContent";
import { SettingsContainerTitle } from "./SettingsContainerTitle/SettingsContainerTitle";

export const Root = SettingsContainerRoot;
export const Nav = SettingsContainerNav;
export const Content = SettingsContainerContent;
export const Title = SettingsContainerTitle;
